const LEADING_WHITESPACE_PATTERN = /^[\t\n\f\r ]+/;

function readLeadingComment(html: string) {
  if (!html.startsWith('<!--')) return null;

  const closingIndex = html.indexOf('-->');
  if (closingIndex === -1) return null;

  const source = html.slice(0, closingIndex + 3);
  const template = document.createElement('template');
  template.innerHTML = source;
  const [comment, ...remainder] = template.content.childNodes;

  return comment?.nodeType === Node.COMMENT_NODE && remainder.length === 0
    ? source
    : null;
}

export function splitPageHtmlPrefix(html: string) {
  const tokens: string[] = [];
  let remainingHtml = html;

  while (remainingHtml) {
    const whitespace = remainingHtml.match(LEADING_WHITESPACE_PATTERN)?.[0];

    if (whitespace) {
      tokens.push(whitespace);
      remainingHtml = remainingHtml.slice(whitespace.length);
      continue;
    }

    const comment = readLeadingComment(remainingHtml);
    if (!comment) break;

    tokens.push(comment);
    remainingHtml = remainingHtml.slice(comment.length);
  }

  return { tokens, remainingHtml };
}
